import { PayloadAction, createSlice } from "@reduxjs/toolkit";
export interface s3UploadReducer {
  uploading: boolean;
  success: boolean | null;
  successResponce: {};
  presignedUrl: string;
  error: {} | null;
}
export const initialState: s3UploadReducer = {
  uploading: false,
  success: null,
  error: null,
  presignedUrl: '',
  successResponce: {},
};
export const s3UploadSlice = createSlice({
  name: "s3UploadSlice",
  initialState,
  reducers: {
    uploadImageRequest: (state, action) => {

      state.successResponce = {};
      state.uploading = true;
      state.success = null;
      state.error = null;
    },
    uploadImageSuccess: (state, action: PayloadAction<{}>) => {
      state.successResponce = action.payload;
      state.uploading = false;
      state.success = true;
    },
    uploadImageFailure: (state, action) => {
      state.uploading = false;
      state.success = false;
      state.error = action.payload;
    },

    getPresignedUrl: (state, action) => {
      state.uploading = true;
    },
    getPresignedUrlSuccess: (state, action) => {
      state.presignedUrl = action.payload;
      state.uploading = false;
    },
    getPresignedUrlFailure: (state, action) => {
      state.uploading = false;
    }
  },
});
export const {
  uploadImageRequest,
  uploadImageSuccess,
  uploadImageFailure, getPresignedUrl, getPresignedUrlSuccess, getPresignedUrlFailure
} = s3UploadSlice.actions;

export default s3UploadSlice.reducer;